import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6840476c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "navbar__title" }

import {computed, onMounted, ref} from "vue";
import IconChevron from "@/assets/icons/icon__chevron.svg"
import {useI18n} from "vue3-i18n";
import {useRouter} from "vue-router";
import {useMemberStore} from "@/stores/memberStore";
import {Role} from "@/types";
import AdminNavbarItems from "@/components/navigation/AdminNavbarItems.vue";
import CorporateMemberNavbarItems from "@/components/navigation/CorporateMemberNavbarItems.vue";
import SyndicateAdminMemberNavbarItems from "@/components/navigation/SyndicateAdminMemberNavbarItems.vue";
import SyndicateCoownerMemberNavbarItems from "@/components/navigation/SyndicateCoownerMemberNavbarItems.vue";
import IndividualMemberNavbarItems from "@/components/navigation/IndividualMemberNavbarItems.vue";
import IndividualAndSyndicateCoownerMemberNavbarItems
  from "@/components/navigation/IndividualAndSyndicateCoownerMemberNavbarItems.vue";
import RealEstateBrokerMemberNavbarItems from "@/components/navigation/RealEstateBrokerMemberNavbarItems.vue";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: {
    memberIsLoading: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "8f0f8aea": (_unref(height))
}))

const props = __props

const {t} = useI18n()

const memberStore = useMemberStore()

let isExpanded = ref<boolean>(true);
let content = ref<HTMLElement>();
let height = ref<string>();

const router = useRouter();
const currentRoute = ref(router.currentRoute);
let rootRouteName = computed(() => {
  let name = currentRoute.value.name;

  if (currentRoute.value.matched[0] != null) {
    name = currentRoute.value.matched[0].name
  }

  return name?.toString()
})


onMounted(() => {
  height.value = `${
      content.value != undefined ? content.value.scrollHeight : 0
  }px`;

  //close it once we have the scroll value
  toggleExpansion();
});

function toggleExpansion() {
  isExpanded.value = !isExpanded.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$windowWidth < 1225)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)("global.menu")), 1),
          (_ctx.$router.currentRoute.value.name)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "navbar__drawer-btn",
                onClick: toggleExpansion
              }, [
                _createTextVNode(_toDisplayString(_unref(t)(`routes.${_unref(rootRouteName)}.name`)) + " ", 1),
                _createVNode(_unref(IconChevron), {
                  class: _normalizeClass([{'icon--rotate-180' : !_unref(isExpanded)}, "icon icon--white"])
                }, null, 8, ["class"])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "expand" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "content",
          ref: content,
          class: "navbar__content"
        }, [
          (_unref(memberStore).hasRole(_unref(Role).Admin))
            ? (_openBlock(), _createBlock(AdminNavbarItems, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasRole(_unref(Role).CorporateAdmin))
            ? (_openBlock(), _createBlock(CorporateMemberNavbarItems, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasRole(_unref(Role).RealEstateBroker))
            ? (_openBlock(), _createBlock(RealEstateBrokerMemberNavbarItems, { key: 2 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasOneOfTheseRoles([_unref(Role).RegularSyndicateAdmin, _unref(Role).RegularSyndicateManager]))
            ? (_openBlock(), _createBlock(SyndicateAdminMemberNavbarItems, { key: 3 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasIndividualAndCoOwnerRoles())
            ? (_openBlock(), _createBlock(IndividualAndSyndicateCoownerMemberNavbarItems, { key: 4 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasRole(_unref(Role).RegularSyndicateCoOwner) && !_unref(memberStore).hasRole(_unref(Role).RegularIndividual))
            ? (_openBlock(), _createBlock(SyndicateCoownerMemberNavbarItems, { key: 5 }))
            : _createCommentVNode("", true),
          (_unref(memberStore).hasRole(_unref(Role).RegularIndividual) && !_unref(memberStore).hasRole(_unref(Role).RegularSyndicateCoOwner))
            ? (_openBlock(), _createBlock(IndividualMemberNavbarItems, { key: 6 }))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.memberIsLoading && (_unref(isExpanded) || _ctx.$windowWidth >= 1225  || !_ctx.$router.currentRoute.value.name)]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})